<script lang="ts">
	export let circleFill = "#fff";
	export let trashPathFill = "#6d6f76";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 60 60">
	<circle cx="30" cy="30" r="30" style={`fill:${circleFill};opacity:.7`} />
	<g>
		<g>
			<path
				d="M718.279 82.412h-38.308a.857.857 0 0 1 0-1.713h38.308a.857.857 0 0 1 0 1.713z"
				transform="translate(-669.548 -65.49)"
				style={`fill:${trashPathFill}`} />
		</g>
		<g>
			<path
				d="M709.786 116.94h-21.53a3.424 3.424 0 0 1-3.357-2.647l-6.458-27.749a.825.825 0 0 1 .624-.99.836.836 0 0 1 1 .619l6.457 27.749a1.769 1.769 0 0 0 1.734 1.367h21.531a1.767 1.767 0 0 0 1.734-1.367l6.458-27.749a.836.836 0 0 1 1-.619.825.825 0 0 1 .624.99l-6.457 27.749a3.424 3.424 0 0 1-3.36 2.647z"
				transform="translate(-669.444 -66.184)"
				style={`fill:${trashPathFill}`} />
		</g>
		<g transform="translate(26.19 9.382)">
			<circle cx="3.342" cy="3.342" r="3.342" style={`fill:${trashPathFill}`} />
		</g>
		<g>
			<path
				d="M696.051 113.2a.857.857 0 0 1-.85-.766l-2.733-25.953a.856.856 0 1 1 1.7-.18l2.733 25.953a.856.856 0 0 1-.762.941.815.815 0 0 1-.088.005z"
				transform="translate(-671.836 -67.365)"
				style={`fill:${trashPathFill}`} />
		</g>
		<g>
			<path
				d="M707.938 113.2a.816.816 0 0 1-.091-.005.856.856 0 0 1-.762-.941l2.733-25.954a.857.857 0 1 1 1.7.179l-2.733 25.952a.857.857 0 0 1-.847.769z"
				transform="translate(-674.324 -67.365)"
				style={`fill:${trashPathFill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	circle,
	path {
		transition: fill 0.5s;
	}

</style>
